import React from "react";
import {
  BookOpen,
  Code,
  Info,
  List,
  ShieldCheck,
  Users,
  UploadCloud,
} from "lucide-react";

function DocComponent() {
  const sections = [
    {
      title: "Introduction",
      icon: <Info className="text-indigo-600" size={20} />,
      description:
        "Overview of CelystikHub's mission, architecture, and how it enables decentralized innovation. Learn the core philosophy before diving in.",
    },
    {
      title: "Developer Docs",
      icon: <Code className="text-purple-600" size={20} />,
      description:
        "Guides, API references, smart contract standards, and integration steps for developers building on CelystikHub.",
    },
    {
      title: "User Guidelines",
      icon: <BookOpen className="text-green-600" size={20} />,
      description:
        "Step-by-step instructions for innovators, contributors, investors, and general users to navigate the platform effectively.",
    },
    {
      title: "Glossary",
      icon: <List className="text-amber-600" size={20} />,
      description:
        "A comprehensive glossary explaining key terms used across the Celystik ecosystem, protocols, and smart contract interactions.",
    },
    {
      title: "Community",
      icon: <Users className="text-pink-600" size={20} />,
      description:
        "Join discussions, contribute feedback, and participate in forums that shape the evolution of CelystikHub.",
    },
    {
      title: "Security",
      icon: <ShieldCheck className="text-red-600" size={20} />,
      description:
        "Understand our commitment to security, audit processes, and how we protect your assets and intellectual contributions.",
    }
  ];

  return (
    <div className="min-h-screen px-6 py-10 sm:px-10 bg-gradient-to-b from-indigo-50 via-white to-indigo-100">
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-8 text-start">
        Documentation
      </h1>

      {/* Cards first, centered grid */}
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 mb-12">
        {sections.map((section, index) => (
          <div
            key={index}
            className="bg-white border border-gray-200 rounded-xl shadow-sm p-6 hover:shadow-md transition"
          >
            <div className="flex items-center mb-4 gap-3">
              {section.icon}
              <h2 className="text-lg font-semibold text-gray-800">
                {section.title}
              </h2>
            </div>
            <p className="text-sm text-gray-600">{section.description}</p>
          </div>
        ))}
      </div>

      {/* Descriptive Paragraph */}
      <p className="text-start text-gray-600 max-w-4xl mx-auto leading-relaxed text-sm sm:text-base">
        The full documentation will be embedded here from Gitbook. Meanwhile, we’ve provided a preview of the upcoming structure. The documentation will be refined and revised for clarity and depth. This structure is designed to streamline onboarding, empower developers, and align contributors across all phases of innovation.
      </p>
    </div>
  );
}

export default DocComponent;
